import { useState } from "react";
import {
  GetNotificationInfoQueryVariables,
  useGetNotificationInfoQuery,
} from "views/utils/graphql/graphql";

export const useGetNoticeDetail = (
  initVariables: GetNotificationInfoQueryVariables
) => {
  const [noticeDetailVariables, setNoticeDetailVariables] =
    useState<GetNotificationInfoQueryVariables>(initVariables);
  const [noticeDetail, getNoticeDetail] = useGetNotificationInfoQuery({
    variables: noticeDetailVariables,
    requestPolicy: "network-only",
  });

  return {
    noticeDetail,
    getNoticeDetail,
    setNoticeDetailVariables,
  };
};
